export default __webpack_public_path__ + "static/img/awarness_bg.3cf1f87.jpg";